module.exports = __webpack_public_path__ + "img/3.7fffb4eb.svg";